import { NgModule } from '@angular/core';

import { UgcLinksContentPipe } from './UgcLinksContent.pipe';

@NgModule({
  declarations: [UgcLinksContentPipe],
  exports: [UgcLinksContentPipe],
})
export class UgcLinksContentPipeModule {}
